module.exports = __webpack_public_path__ + "img/f30.594788a6.jpg";